<template>
  <Content id="kindergartens">
    <div slot="search">
      <Form :label-width="50" :model="search">
        <Row>
          <Col>
            <FormItem label="名称">
              <Input v-model="search.name"/>
            </FormItem>
          </Col>
          <Col>
            <FormItem label="状态">
              <Select v-model="search.status" style="width:100px;">
                <Option v-for="item in statusList" :value="item.value" v-bind:key="item.value"  >{{ item.label }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col>
            <div style="display:flex;">
              &nbsp;&nbsp;<Button type="primary" @click="handleDataList">搜索</Button>
            </div>
          </Col>
        </Row>
      </Form>

      <div slot="extra" style="margin-bottom: 5px; display: flex;width: 100%" >
        <div style="float: left;">
          <Button type="primary" size="small" icon="md-add" @click="handleCreate">添加</Button>
        </div>
      </div>

    </div>

    <ITable ref="list" stripe :columns="columns" :loading="list.loading" :data="list.data" :total="list.total"
      @on-page-change="handleDataList" @on-selection-change="handleSelectionChange" />

    <KindergartenEdit ref="edit" @on-update="handleDataList" />
  </Content>
</template>
<script>
import {_del, _getPagesList, _updateStatus} from "@/services/manage/kindergartens";
import KindergartenEdit from "./KindergartenEdit";
export default {
  name: "Kindergartens",
  components: {
    KindergartenEdit
  },
  data() {
    return {
      // 表单数据
      search: {
        name: "",
        status: 1,
      },
      list: {
        data: [],
        total: 0,
        loading: false
      },
      statusList: [
        {label: '启用', value: 1},
        {label: '禁用', value: 2},
      ],
      columns: [
        {
          title: "名称",
          key: "name",
          minWidth: 200,
          visible: true,
        },
        {
          title: "联系电话",
          key: "phone",
          minWidth: 130,
        },
        {
          title: "联系地址",
          key: "address",
          minWidth: 250,
        },
        {
          title: "状态",
          key: "status",
          minWidth: 60,
          render: (h, params) =>{
            return this.$Utils.operatorBtn_FORMAT(h,params,
              {
                type: 'switch',
                paramName: 'status',
                confirm: true,
                value: params.row.status,
                callback: this.handleEditStatus
              },
            )
          }
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          fixed: "right",
          minWidth: 150,
          render: (h, params) => this.$Utils.operatorBtn_FORMAT(h,params,
              {
                type: 'edit',
                confirm: false,
                callback: this.handleEdit
              },
              {
                type: 'delete',
                confirm: true,
                callback: this.handleRemove
              }
          )
        }
      ]
    };
  },
  mounted() {
    if (this.$userSession.checkInstitutionId()) {
      this.handleDataList();
    }
  },
  methods: {
    handleDataList(type) {
      if (!this.$userSession.checkInstitutionId()) {
        this.$message.warning('请先选择机构');
        return;
      }

      this.$Loading.start();
      this.list.loading = true;
      const page = this.$refs["list"].handlePage(type);
      // 模拟异步请求(搜索)
      setTimeout(() => {
        _getPagesList({
          ...this.search,
          currentPage: page.current,
          pageSize: page.pageSize
        }).then(res => {
            this.$Loading.finish();
            if (res.errcode === 1){
              const { records, total } = res.data;
              this.list = {
                data: records,
                total: total,
                loading: false
              };
            } else {
              this.$message.error(res.errmsg)
              this.list = {
                data: [],
                total: 0,
                loading: false
              };
            }
          }).catch(() => {
            this.$Loading.error();
            this.list.loading = false;
          });
      }, 500);
    },
    handleCreate() {
      this.$refs["edit"].handleModal("新增");
    },
    handleEdit(row) {
      this.$refs["edit"].handleModal("编辑", row);
    },
    handleRemove(row) {
      this.$Loading.start();
      this.list.loading = true;
      setTimeout(() => {
        _del({
          id: row.id
        }).then(res => {
            if (res.errcode === 1){
              this.$message.success("删除成功")
              this.handleDataList();
            } else{
              this.$message.error(res.errmsg);
            }
          })
          .catch(() => {
            this.$Loading.error();
            this.list.loading = false;
          });
      }, 500);
    },
    handleSelectionChange(selection) {
      const ids = [];
      for (const item of selection) {
        ids.push(item["id"]);
      }
      this.toolbar = {
        ids: ids,
        number: selection.length
      };
    },
    handleEditStatus(row, index, targetValue){
      if(row && row.id){
        return new Promise((resolve,reject) => {
          this.$confirm(`是否确定${targetValue === 1 ? "启用" : "停用"}${row.name}吗?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            dangerouslyUseHTMLString: true,
            type: 'warning'
          }).then(()=>{
            _updateStatus({id:row.id, status: targetValue}).then(res =>{
              if (res.errcode !== 1) {
                this.$message.error(res.errmsg);
              }
            }).catch(() => {
              this.$Loading.error();
              this.list.loading = false;
            });
          }).catch(() => {

          }).finally(() => {
            this.handleDataList();
          })
        });
      }
    },
  }
};
</script>
<style lang="postcss" scoped>

</style>
